@if (
  versionChecker.isNewVersionAvailable && appStorage.useMode !== LoginMode.URL
) {
  <tratt-version-notification
    class="position-absolute top-0 start-50 translate-middle-x"
    [i18n]="{
      'reload now': 'g.reload now' | transloco,
      later: 'g.later' | transloco,
      'new update': {
        header: 'toasts.new update.header' | transloco,
        body: 'toasts.new update.body' | transloco,
      },
    }"
  ></tratt-version-notification>
}

<div class="overflow-box position-relative">
  <tratt-alert id="alerts"></tratt-alert>
  <tratt-modal></tratt-modal>
  <header>
    <tratt-navigation #navigation></tratt-navigation>
  </header>
  <main style="margin-top: 40px">
    @if (environment.beta_version && !localOnly) {
      <div class="d-none d-md-block beta_mark text-outline-white">beta</div>
    }
    <div class="container-fluid flex">
      <router-outlet></router-outlet>
    </div>
    <!-- /.container -->
  </main>
</div>
